
import { useDispatch as rdUseDispatch, useSelector, useStore, connect } from 'react-redux';
export {
  useLocation,
  useHistory,
  useParams,
  useRouteMatch,
  matchPath,
  NavLink,
  Link,
} from '@@/core/history';

export { useSelector, useStore, connect };

export function useDispatch() {
  return rdUseDispatch();
}
